module.exports = __webpack_public_path__ + "media/Images/icon-playbook-o-be4935d434782822a64e80fa24367016.svg";